const ModalContent={

    PRIVATE_ROUTE_MESSAGE:"Please Login to access this page!",
    TERMS_AND_CONDITION:"The standard terms and conditions of the main contract apply. If the subscriber violates the main terms of service including the monthly subscription fee, or if there is any technical problem beyond Carrier's control, Carrier has the right to cancel and suspend your e-SIM subscription.\nUsers will only be able to pair 'Series 3' and above watches with a qualified iPhone device.",
    INVALID_REQUEST:"Not a valid request. Please try again!",
    SUSPEND_RESUME_DELETE_CONNECTION_CONFIRMATION_MESSAGE :"Connection {{action}} is in progress. You will be updated via SMS when completed.",
    NOT_ELIGIBLE_MESSAGE:"Sorry! The multi-SIM service cannot be activated on this connection.",
    INVALID_ID_NUMBER_MESSAGE:"The NIC number you entered is incorrect. Please insert the correct NIC number of the connection.",
    SUSPEND_RESUME_SERVICE_MESSAGE:"The multi-device service on the selected device will be {{action}}.",
    DELETE_SERVICE_MESSAGE:"The connection will be removed.",
    GENERAL_ERROR_DESCRIPTION:"Something went wrong! Please try again later.",

}

export default ModalContent;